import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './style/roundicon.scss';

/**
 * Round icon component
 *
 * can optionally have children that will render (vertically aligned) to the right of the icon
 *
 * @example
 * <RoundIcon
 *     classes={{ root: style.root }}
 *     circleSize={ 1.75 }
 *     iconSize={ 0.875 }
 *     iconType={ 'desktop' }
 *     background={ '#ff0000' }
 *     initials = { '' }
 * />
 */
export default class RoundIcon extends Component {
    render() {
        const { classes, circleSize, iconSize, iconType, initials, children } = this.props;

        return (
            <div className={ `${style.roundIcon} ${classes.root}` }>
                <figure className={ style.roundIcon__figure }>
                    <span
                        className={ `${style.roundIconFigure__wrapper} ${classes.roundIconFigureWrapper}` }
                        style={{
                            width: `${circleSize}rem`,
                            height: `${circleSize}rem`,
                            borderRadius: `${circleSize}rem`,
                            fontSize: `${iconSize}rem`
                        }}>
                        { initials ? initials : <div>
                            { iconType ? <FontAwesomeIcon
                                icon={ iconType }
                                style={{
                                    width: `${iconSize}rem`,
                                    height: `${iconSize}rem`,
                                    fontSize: `${iconSize}rem`
                                }}/> : null }
                        </div> }
                    </span>
                </figure>
                { children }
            </div>
        );
    }
}

RoundIcon.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string,
        roundIconFigureWrapper: PropTypes.string
    }),
    circleSize: PropTypes.number,
    iconSize: PropTypes.number,
    iconType: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    score: PropTypes.bool,
    initials: PropTypes.string
};

RoundIcon.defaultProps = {
    classes: {
        root: '',
        roundIconFigureWrapper: ''
    },
    circleSize: 1,
    iconSize: 1,
    iconType: 'desktop',
    initials: ''
};
